export const HRExpenseClaimHeaders = {
  ClaimNo: 'Claim No',
  ClaimDt: 'Claim Date',
  Employee: 'Employee',
  Curr: 'Currency',
  Amount: 'Amount',
  ClaimStatus: 'Status',
  'Settlement Date': 'Settlement Date',
};

export const HRProcessClaimHeaders = {
  ClaimNo: 'Claim No',
  ClaimDt: 'Date',
  Employee: 'Employee',
  Entity: 'Entity',
  Department: 'Department',
  Curr: 'Currency',
  Amount: 'Amount',
};

export const HREXPENSE_CODETYPES = {
  EXPENSE_GRP: 'EXPENSE_GRP',
  EXPENSE_CATEGORY: 'EXPENSE_CATEGORY',
  EXPENSE_TYPE: 'EXPENSE_TYPE',
  EMPLOYEE: 'EMPLOYEE',
};
